import { Fragment, type FC } from 'react';

import { type LoggingContext } from '#packages/data-collection/types/logging-context';
import { type ViewModelProps } from '#packages/web/types/view-model-props';
import { LoadingPage } from '#packages/web/layouts/page/templates';

import { ThrowError } from '#apps/client-web/app/components/throw-error';

import { type EcmsFormPageViewModel } from './audit-form-ecms-page.view-model';
import { AuditFormEcmsPageRenderer } from './audit-form-ecms-page.renderer';

export type AuditFormEcmsPageContainerProps =
  ViewModelProps<EcmsFormPageViewModel> & LoggingContext;

export const AuditFormEcmsPageContainer: FC<
  AuditFormEcmsPageContainerProps
> = ({ viewModel }) => {
  const { loadAuditFormState, updateMutationState, form, onSubmit } = viewModel;

  return (
    <Fragment>
      {/* Loading */}
      {loadAuditFormState.state === 'loading' && <LoadingPage />}

      {/* Success */}
      {loadAuditFormState.state === 'success' && (
        <AuditFormEcmsPageRenderer
          form={form}
          onSubmit={onSubmit}
          isPending={updateMutationState.state === 'pending'}
        />
      )}

      {/* Error */}
      {loadAuditFormState.state === 'error' && (
        <ThrowError error={loadAuditFormState.error} />
      )}

      {/* Mutation error */}
      {updateMutationState.state === 'error' && (
        <ThrowError error={updateMutationState.error} />
      )}
    </Fragment>
  );
};
